import React, { Component } from 'react';
import { colors } from '../../../constants';
import './ColorList.css';

class ColorList extends Component {

    state = {
        color: colors
    };

    render() {
        let count = 0 ;
        let colorCount = 0
        let list = this.props.circleData ? this.props.circleData.map((circleItem,key) => {
            if (this.props.groupId === circleItem.groupId) {
                
                // let color = this.state.color.find(r => r.key === circleItem.key) ? this.state.color.find(r => r.key === circleItem.key).color : this.state.color[0].color;
                let color = !circleItem.competitorId
                if(color){
                    count += 1
                    colorCount = 0
                }else{
                    colorCount+=1
                }
                return (
                    <li>
                        <div style={{ backgroundColor: '#' + this.state.color[count].color[colorCount] }}></div>
                        <p>{circleItem.name}</p>
                    </li>
                )
            }
        }) : '';

        return (
            <ul>
                {list}
            </ul>

        );
    }
}

export default (ColorList);



// WEBPACK FOOTER //
// ./src/components/Prioritizer/SegmentPriority/TabContent/ColorList/ColorList.jsx